import { SIGN_IN, SIGN_OUT } from './authTypes';

const INITIAL_STATE = {
  authStatus: false,
};

const authReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SIGN_IN:
      return { ...state, authStatus: true };
    case SIGN_OUT:
      return { ...state, authStatus: false };
    default:
      return state;
  }
};

export default authReducer;
